import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, filter, map, of } from 'rxjs';
import { LessonActions } from './lesson.actions';
import { LessonFacade } from './lesson.facade';
import { TaskModalActions } from '../task/task.actions';
import { ApplicationFacade } from '@lyceo/shared/data-access';
import { PlanFacade } from '../plan/plan.facade';
import { isDefined } from '@lyceo/shared/util';
import { TranslocoService } from '@jsverse/transloco';
import { PlanPageActions } from '../plan/plan.actions';
import { LessonService } from '../../lesson.service';
import {
  PupilContextActions,
  PupilContextFacade,
} from '@lyceo/shared/pupil-context/data-access';

@Injectable()
export class LessonEffects {
  private readonly actions$: Actions = inject(Actions);
  private readonly lessonFacade: LessonFacade = inject(LessonFacade);
  private readonly lessonService: LessonService = inject(LessonService);
  private readonly applicationFacade: ApplicationFacade =
    inject(ApplicationFacade);
  private readonly planFacade: PlanFacade = inject(PlanFacade);
  private readonly pupilContextFacade: PupilContextFacade =
    inject(PupilContextFacade);
  private readonly translocoService: TranslocoService =
    inject(TranslocoService);

  public getLessonsForSelectedDate$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(
        PupilContextActions.setPupilContext,
        PlanPageActions.calendarDayClicked,
      ),
      map((action) =>
        action.type === PupilContextActions.setPupilContext.type
          ? action.pupilContext?.homiPersonId
          : this.pupilContextFacade.homiPersonId(),
      ),
      filter(isDefined),
      exhaustMap((homiPersonId) =>
        this.lessonService
          .getLessonsByDate(homiPersonId, this.planFacade.selectedDate())
          .pipe(
            map((lessons) =>
              LessonActions.getLessonsByDaySuccess({ lessons: lessons }),
            ),
            catchError((error: Error) =>
              of(LessonActions.getLessonsByDayFailure({ error })),
            ),
          ),
      ),
    );
  });
}
